import { ApiUrl } from '@common/enums';
import { ApplianceModel } from '@common/models';
import { CommonProductQueryParams } from '@ee-api/queryParams';

import { staticContentService } from '../staticContentService';

const cookingApplianceApi = staticContentService.injectEndpoints({
    endpoints: (builder) => ({
        fetchCustomerSuppliedCookingAppliances: builder.query<ApplianceModel[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.CUSTOMER_SUPPLIED_COOKING_APPLIANCES,
                method: 'GET',
                params,
            }),
        }),
        fetchInStoreCookingAppliances: builder.query<ApplianceModel[], { url: string }>({
            query: ({ url }) => ({
                url,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useLazyFetchCustomerSuppliedCookingAppliancesQuery,
    useFetchCustomerSuppliedCookingAppliancesQuery,
    useFetchInStoreCookingAppliancesQuery,
} = cookingApplianceApi;
